<template>
  <div class="load-more-button">
    <template v-if="!finished">
      <div v-if="loading" class="rk-load-button">{{ $t('正在加载') }} <i class="iconfont icon-jiazai"></i></div>
      <div v-else class="rk-load-button" @click="$emit('click')">
        {{ $t('显示更多') }}<i class="iconfont icon-xiangxia"></i>
      </div>
    </template>
    <div v-else class="rk-load-button">{{ $t('没有更多了') }}</div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    finished: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.load-more-button {
  .rk-load-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 0;
    //border-top: 1px solid var(--border-color-1);
    text-align: center;
    font-size: 13px;
    color: var(--font-color-3);
  }
  .iconfont {
    font-size: 14px;
    margin-left: 5px;
  }
  .icon-jiazai {
    animation: rotating 2s linear infinite;
  }
  @keyframes rotating {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
